import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NewButton, Icon } from '../../../../../components';

const URLContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledLink = styled.a`
  color: var(--link-default);
  text-decoration: none;
  outline: none;
  &:hover {
    text-decoration: underline;
  }
`;

const URLCell = ({ url }) => (
  <URLContainer>
    <StyledLink href={url} target='_blank' rel='noopener noreferrer'>
      {url}
    </StyledLink>
    <NewButton onClick={() => navigator.clipboard.writeText(url)} secondary>
      <Icon name='copy' displaySize={16} />
    </NewButton>
  </URLContainer>
);

URLCell.propTypes = {
  url: PropTypes.string.isRequired
};

export { URLCell };
